module.exports = __webpack_public_path__ + "img/ordernum.e5c75138.svg";